import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=5d04391e&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pay.vue?vue&type=style&index=1&id=5d04391e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d04391e",
  null
  
)

export default component.exports